import { useState, useContext } from 'react';
import { ThemeContext } from '../../../context/ThemeContext';
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import SearchBar from '../searchBar/SearchBar';
import sectorsByCategory from '../../../assets/data/category';

function FilterMobile() {
  const { selectedFilter, setSelectedFilter, setInputValue } = useContext(ThemeContext);
  const [selectedDropdownCategory, setSelectedDropdownCategory] = useState('');
  const [selectedDropdownSector, setSelectedDropdownSector] = useState('');

  const handleFilterSelection = (value, category) => {
    setSelectedFilter(value);
  };

  const clearFilters = () => {
    setSelectedFilter(null);
    setInputValue('');
    setSelectedDropdownCategory('');
    setSelectedDropdownSector('');
  };

  const handleDropdownCategoryChange = (event) => {
    setSelectedDropdownCategory(event.target.value);
    setSelectedDropdownSector('');
  };

  const handleDropdownSectorChange = (event) => {
    const sector = event.target.value;
    setSelectedDropdownSector(sector);
    handleFilterSelection(sector, selectedDropdownCategory);
  };

  return (
    <Box
      sx={{
        display: { xs: 'block', mdlg: 'none' },
        width: '100%',
        bgcolor: '#fff',
        p: 0,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: 1,
          mb: 2,
          bgcolor: '#242424',
          p: 1,
          borderRadius: '5px',
        }}
      >
        <Box sx={{ width: '60%' }} >
          <SearchBar width="100%" height="5vh" />
        </Box>
        <Button
          variant="standard"
          onClick={clearFilters}
          sx={{ width: '35%', fontSize: { xs: '0.68rem', md:'0.8rem' }, fontWeight: { xs: '900', md: '600' }, color: '#55d6aa' }}
        >
          Clear Filters
        </Button>
      </Box>

      <FormControl size="small" fullWidth sx={{ mb: 2 }}>
        <InputLabel>Category</InputLabel>
        <Select
          value={selectedDropdownCategory}
          label="Category"
          onChange={handleDropdownCategoryChange}
        >
          {Object.keys(sectorsByCategory).map((cat) => (
            <MenuItem key={cat} value={cat}>
              {cat}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl
        size="small"
        fullWidth
        disabled={!selectedDropdownCategory}
        sx={{ mb: 2 }}
      >
        <InputLabel>Sector</InputLabel>
        <Select
          value={selectedDropdownSector}
          label="Sector"
          onChange={handleDropdownSectorChange}
        >
          {selectedDropdownCategory &&
            sectorsByCategory[selectedDropdownCategory]?.map((sector, index) => (
              <MenuItem key={index} value={sector}>
                {sector}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export default FilterMobile;
